import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import ClientPortal from './ClientPortal';
import reportWebVitals from './reportWebVitals';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Log with sanitized component stack (no sensitive data in stack traces)
    console.error('[AppErrorBoundary] Caught render error:', {
      message: error.message,
      componentStack: (info.componentStack || '').split('\n').slice(0, 10).join('\n'),
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', padding: '32px',
          fontFamily: 'system-ui, sans-serif', background: '#F8FAFC',
        }}>
          <div style={{
            maxWidth: 480, background: '#fff', border: '1px solid #E2E8F0',
            borderRadius: 12, padding: 32, boxShadow: '0 2px 12px rgba(0,0,0,.08)',
          }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
            <h2 style={{ margin: '0 0 8px', color: '#1E293B', fontSize: 20 }}>
              Something went wrong
            </h2>
            <p style={{ margin: '0 0 20px', color: '#64748B', lineHeight: 1.5 }}>
              An unexpected error occurred while displaying the page. Your account
              data is preserved — reloading will restore it.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#2563EB', color: '#fff', border: 'none',
                borderRadius: 8, padding: '10px 20px', fontSize: 14,
                fontWeight: 600, cursor: 'pointer', marginBottom: 16,
              }}
            >
              Reload Application
            </button>
            <details style={{ marginTop: 8 }}>
              <summary style={{ color: '#94A3B8', fontSize: 12, cursor: 'pointer' }}>
                Error details (for support)
              </summary>
              <pre style={{
                marginTop: 8, padding: 12, background: '#F1F5F9',
                borderRadius: 6, fontSize: 11, color: '#475569',
                whiteSpace: 'pre-wrap', wordBreak: 'break-word',
              }}>
                {this.state.error.message}
              </pre>
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/portal/:portalId" element={<ClientPortal />} />
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
